<script setup lang="ts">
import type { IMenuItem } from "@/components/legacy/Menu/menu.interface"
import logo from "@brand-logo"
import footerLogo from "@brand-logo-footer"
import { AppLink, Button, Icon } from "@/components/ui"
import MobileMenuItem from "./MobileMenuItem.vue"

interface NavMobileMenuProps {
  items?: IMenuItem[]
}

withDefaults(defineProps<NavMobileMenuProps>(), {
  items: () => [],
})

defineEmits<{
  (e: "close"): void
}>()
</script>

<template>
  <div class="bg-[#e4d2be] absolute min-h-screen w-screen left-0 top-0 right-0 z-10">
    <div
      class="bg-[#e4d2be] sticky top-0 left-0 right-0 flex items-center justify-between border-b border-b-black py-3 z-10"
    >
      <AppLink to="/">
        <img class="gpx-brand" :src="logo" alt="Logo">
      </AppLink>
      <div class="block z-20">
        <Button variant="flat" @click="$emit('close')">
          <span class="sr-only">Close menu</span>
          <Icon icon="Close" size="sm" />
        </Button>
      </div>
    </div>

    <ul class="flex flex-col py-10 px-4">
      <MobileMenuItem
        v-for="(item, index) in items" :key="`${item.key}-${index}`" :item="item" as="li"
        @navigate="$emit('close')"
      />
    </ul>
    <div class="bg-[#e4d2be] sticky bottom-0 left-0 right-0 flex w-full items-center justify-center py-4">
      <img :src="footerLogo" class="gpx-brand" alt="Logo" loading="lazy">
    </div>
  </div>
</template>

<style scoped>
.gpx-brand {
  max-height: 56px;
}
</style>
